import { Api } from 'models/services/api';
import { ReadRelationshipsByOriginalIdQuery } from 'models/services/graphql';

import { RelationshipCollectionData } from '../collection';

type DataToFetch = {
  originalId: string;
  limit?: number;
  nextToken?: string;
};

const RequestQuery = `
  query ReadRelationshipsByOriginalId($originalId: ID!, $limit: Int, $nextToken: String) {
    ${ReadRelationshipsByOriginalIdQuery}
  }
`;

type ResponseData = {
  data: {
    readRelationshipsByOriginalId: RelationshipCollectionData;
  }
}

class ReadCollectionByOriginalIdGql {

  readonly result?: RelationshipCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readRelationshipsByOriginalId;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionByOriginalIdGql };
